/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import alert from "../../../assets/images/alert-circle.svg";

const ModalMPSEventRegistrationFailure = ({ handleClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-opacity-100 bg-grey-25">
      <div className="justify-center w-full max-w-md p-6 bg-white shadow-lg rounded-2xl">
        <div className="flex justify-center space-x-4">
          <img src={alert} alt="alert" className="size-20" />
        </div>
        <h2 className="justify-center mt-4 mb-6 text-lg font-semibold text-center text-grey-900">
          There was an error saving you changes
        </h2>
        <p className="mb-6 text-sm text-center text-grey-600">
          {/* {`Keep editing, or save as a draft to work on it later`} */}
        </p>
        <div className="flex justify-center space-x-4">
          {/* <button
            className="px-4 py-3 text-base font-semibold border-2 rounded-lg bg-grey-25 hover:bg-grey-50 text-grey-900 "
            onClick={() => handleClose()}
          >
            Stay on registration page
          </button> */}
          <button
            className="px-4 py-3 text-base font-semibold rounded-lg bg-grey-700 hover:bg-grey-800 text-grey-25"
            onClick={() => {
              handleClose();
            }}
          >
            Stay on registration page
          </button>
        </div>
      </div>
    </div>
  );
};
export default ModalMPSEventRegistrationFailure;
